export const visibleAddressCases = [
  'DELIVERY',
  'DISPLACEMENT',
  'DRONE',
  'DUMP',
  'EVICTION',
  'IMAGE_EDITING',
  'INSPECTION',
  'INSPECTION_AND_ESTIMATE',
  'INSPECTION_AUDITANCE',
  'INSPECTION_CONFERRING_ENTRANCE',
  'INSPECTION_CONSTRUCTION_FINAL',
  'INSPECTION_CONSTRUCTION_INTERMEDIARY',
  'INSPECTION_DELIVERY',
  'INSPECTION_ENTRANCE',
  'INSPECTION_ENTRANCE_HOUSEVIEW',
  'INSPECTION_ENTRANCE_PLUS',
  'INSPECTION_ENTRANCE_PREMIUM',
  'INSPECTION_EXIT',
  'INSPECTION_EXIT_GOLD',
  'INSPECTION_EXIT_HOUSEVIEW',
  'INSPECTION_EXIT_PLUS',
  'INSPECTION_EXIT_PREMIUM',
  'INSPECTION_IB_ENTRANCE',
  'INSPECTION_IB_EXIT',
  'INSPECTION_INTERMEDIARY',
  'INSPECTION_MEASUREMENT',
  'INSPECTION_MINI',
  'INSPECTION_MINI_ENTRANCE_GOLD',
  'INSPECTION_MINI_ENTRANCE_PLUS',
  'INSPECTION_MINI_EXIT',
  'INSPECTION_MINI_EXIT_GOLD',
  'INSPECTION_MINI_EXIT_PLUS',
  'INSPECTION_POST_INSTALLATION',
  'INSPECTION_SHED',
  'INSPECTION_SHED_EXIT',
  'INSPECTION_IMOBMIX_ENTRANCE',
  'INSPECTION_IMOBMIX_EXIT',
  'INSPECTION_TEST',
  'INSPECTION_ENTRANCE_BACKLOG',
  'INSPECTION_EXIT_BACKLOG',
  'INSPECTION_ENTRANCE_ANTICIPATION',
  'INSPECTION_INSURER',
  'INSPECTION_ENTRANCE_GOLD_ONE_OFF',
  'INSPECTION_EXIT_GOLD_ONE_OFF',
  'KEY_DELIVERY',
  'LOFT_VISIT',
  'MISSION',
  'OBSERVED_TRAINING',
  'PHOTOGRAPHY',
  'PHOTOGRAPHY_360',
  'PHOTOGRAPHY_HAUSEFUL',
  'PHOTOGRAPHY_HOME_STAGING',
  'PHOTOGRAPHY_PLUS',
  'PHOTOGRAPHY_PREMIUM',
  'PHOTOGRAPHY_PREMIUM_PLUS_360',
  'PLANNING',
  'REALTY_SUGGESTION',
  'REINSPECTION',
  'REINSPECTION_HAUSEFUL',
  'REMOTE_VISIT',
  'RENT_OUT',
  'SKETCH',
  'TECHNICAL_SKETCH',
  'TECHNICAL_SKETCH_PLUS',
  'TRAINING',
  'VISIT',
  'VISIT_AND_PHOTOS',
  'VISIT_GOLD',
  'VISIT_LIGHT',
  'VISIT_PREMIUM',
  'VISIT_SALE',
  'PHOTOGRAPHY_PLUS_FOTOP',
  'PHOTOGRAPHY_PREMIUM_FOTOP',
  'ROUTINE_INSPECTION',
  'INGOING_INSPECTION',
  'OUTGOING_INSPECTION',
  'VIRTUAL_TOUR',
  'INGOING_INSPECTION_VIRTUAL_TOUR',
  'REVISION_INSPECTION',
  'MEASURE_AND_CAPTURE',
  'INGOING_APARTMENT_THREE_BEDS',
  'INGOING_APARTMENT_FOUR_PLUS_BEDS',
  'INGOING_HOUSE_THREE_BEDS',
  'INGOING_HOUSE_FOUR_BEDS',
  'INGOING_HOUSE_FIVE_PLUS_BEDS',
  'OUTGOING_APARTMENT_THREE_BEDS',
  'OUTGOING_APARTMENT_FOUR_PLUS_BEDS',
  'OUTGOING_HOUSE_THREE_BEDS',
  'OUTGOING_HOUSE_FOUR_BEDS',
  'OUTGOING_HOUSE_FIVE_PLUS_BEDS',
  'QUESTIONNAIRE',
  'GONDOLA',
  'INSPECTION_ENTRANCE_SHORTSTAY',
  'INSPECTION_EXIT_SHORTSTAY',
  'INGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR',
  'INGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR',
  'INGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR',
  'INGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR',
  'INGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR',
  'OUTGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR',
  'OUTGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR',
  'OUTGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR',
  'OUTGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR',
  'OUTGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR',
  'HAUSEFUL_ENTRANCE',
  'HAUSEFUL_EXIT',
  'HAUSEFUL_EXIT_WITHOUT_COMPARISON',
  'INSPECTION_ABANDONMENT_HAUSEFUL',
  'INSPECTION_GIACOMELLI_ENTRANCE',
  'INSPECTION_GIACOMELLI_EXIT',
  'INSPECTION_PRELIMINARY',
  'INSPECTION_PRELIMINARY_TYPE_ONE',
  'INSPECTION_PRELIMINARY_TYPE_TWO',
  'INSPECTION_PRELIMINARY_TYPE_THREE',
  'INSPECTION_ROUTINE_PLUS_VIRTUAL_TOUR',
  'INSPECTION_INGOING_STUDIO',
  'AIRBNB_CLEANING',
  'HEAVY_CLEANING_POST_CONSTRUCTION',
  'INSPECTION_ENTRANCE_BRASILIA_IMOVEIS',
  'INSPECTION_EXIT_BRASILIA_IMOVEIS',
  'REINSPECTION_BRASILIA_IMOVEIS',
  'INSPECTION_ENTRANCE_NEGRAO',
  'INSPECTION_EXIT_NEGRAO',
  'REINSPECTION_NEGRAO',
  'INSPECTION_ENTRANCE_LIGHT',
  'INSPECTION_EXIT_LIGHT_WITH_COMPARISON',
  'INSPECTION_EXIT_LIGHT_WITHOUT_COMPARISON',
  'REINSPECTION_LIGHT',
  'INSPECTION_PRELIMINARY_ROMA',
  'INSPECTION_PRELIMINARY_HAUSEFUL',
  'INSPECTION_DELIVERY_BUILDER',
  'INSPECTION_DELIVERY_STANDARD',
  'INSPECTION_DELIVERY_MEDIUM',
  'INSPECTION_DELIVERY_HIGH_STANDARD',
  'PREVENTIVE_RECORD',
  'PREVENTIVE_RECORD_TYPE_ONE',
  'PREVENTIVE_RECORD_TYPE_TWO',
  'PREVENTIVE_RECORD_TYPE_THREE',
  'INSPECTION_ROUTINE_REPORT_PROPERFY',
  'INSPECTION_NEUTRAL_MODEL_DOMINAI',
  'VISIT_IBAGY',
  'VISIT_RENASCENCA',
]

export const visitTypeServices = [
  'VISIT',
  'VISIT_AND_PHOTOS',
  'VISIT_GOLD',
  'VISIT_LIGHT',
  'VISIT_PREMIUM',
  'VISIT_SALE',
  'LOFT_VISIT',
  'VISIT_IBAGY',
  'VISIT_RENASCENCA',
]

export const evictionTypes = [
  'EVICTION',
]

export const rentOutTypes = [
  'RENT_OUT',
  'RENT_OUT_DUDA',
]

// maybe this can be changed in the future
// to be discussed with the team
export const requiredTenantTypes = [
  // 'HAUSEFUL_ENTRANCE',
  // 'HAUSEFUL_EXIT',
]

export const optionalTenantTypes = [
  'REGISTRATION_AUTHORITY_INSPECTION',
]

export const requiredAttachmentTypes = [
  'REINSPECTION',
  'HAUSEFUL_EXIT',
]

export const isAttachmentRequiredForType = (type) => requiredAttachmentTypes.includes(type)

export const isTenantRequiredForType = (type) => {
  if (optionalTenantTypes.includes(type)) return false

  return (
    visitTypeServices.includes(type) ||
    rentOutTypes.includes(type) ||
    requiredTenantTypes.includes(type)
  )
}

export const uniqueRealtyServiceTypes = evictionTypes.concat(rentOutTypes)

export const appointmentFormSteps = [
  {
    name: 'Serviço',
    valid: true,
  },
  {
    name: 'Data e horário',
    valid: true,
  },
  {
    name: 'Imóveis',
    valid: true,
  },
  {
    name: 'Local de encontro',
    valid: true,
  },
  {
    name: 'Localização da chave',
    valid: true,
  },
  {
    name: 'Dados do visitante',
    valid: true,
  },
]

export const appointmentLocations = [
  {
    value: 'REAL_ESTATE',
    label: 'Imobiliária',
  },
  {
    value: 'REALTY',
    label: 'Imóvel',
  },
  {
    value: 'OTHER',
    label: 'Outro',
  },
]

export const appointmentKeyPicker = [
  {
    value: 'HOST',
    label: 'Host',
  },
  {
    value: 'VISITOR',
    label: 'Visitante',
  },
  {
    value: 'NOT_NEEDED',
    label: 'Não é necessário',
  },
]

export const appointmentKeyLocations = [
  {
    value: 'REAL_ESTATE',
    label: 'Imobiliária',
  },
  {
    value: 'REALTY',
    label: 'Imóvel',
  },
  {
    value: 'OWNER',
    label: 'Dono do Imóvel',
  },
  {
    value: 'OTHER',
    label: 'Outro',
  },
]
